import AxiosInterceptor from "../../AxiosInterceptorHearro";

// 환자 조회
// request data
//  - pid
//  - searchtext
//  - page
//  - order
export function getPatientFromHearro(request) {
    return AxiosInterceptor({
        url: '/main/patient',
        method: 'get',
        params: request
    })
}


// 환자 전체 수 조회
// request data
//  - searchtext
export function getPatientCountFromHearro(request) {
    return AxiosInterceptor({
        url: '/main/patient-count',
        method: 'get',
        params: request
    })
}


// 환자 등록
// request data
//  - displayName: 이름
//  - phoneNumber: 전화번호
//  - birth: 생일
//  - sex: 성별
//  - doctorCode: 처방코드
export function postPatientToHearro(request) {
    return AxiosInterceptor({
        url: '/main/patient',
        method: "post",
        data: request
    })
}


// 환자 삭제
// request data
//  - [pcstId] : 테이블 번호 리스트
export function deletePatientFromHearro(request) {
    return AxiosInterceptor({
        url: '/main/patient',
        method: 'delete',
        data: request
    })
}


// 환자 수정
// request data
//  - displayName: 이름
//  - birth: 생일
//  - sex: 성별
//  - serialNum: 보청기 시리얼 넘버,
//  - hearAidGetDate: 보청기 수령일,
//  - hearAidFitDate": 보청기 피팅일,
//  - phoneNumber: 전화번호
export function putPatientToHearro(request) {
    return AxiosInterceptor({
        url: '/main/patient',
        method: 'put',
        data: request
    })
}


// 환자 처방 코드 발급
export function getPsctCodeFromHearro() {
	return AxiosInterceptor({
		url: '/main/psctcode',
		method: 'get',
	});
}


// 환자 세부 정보
export function getPatientInfoFromHearro(queryStringRequest) {
	return AxiosInterceptor({
		url: '/patient/info',
		method: 'get',
		params: queryStringRequest,
	});
}


// 환자 프로필 사진
export function getPatientProfileImgFromHearro(queryStringRequest) {
    return AxiosInterceptor({
        url: '/patient/profile-img',
        method: 'get',
        params: queryStringRequest,
    })
}
